import { Controller, useFormContext } from 'react-hook-form';

import { Datepicker, DatepickerProps } from '../DatePicker';

interface Props extends DatepickerProps {
	name: string;
}
export const FormDatepicker = ({ name, disabled, ...pickerProps }: Props) => {
	const { control } = useFormContext();

	return (
		<Controller
			name={name}
			control={control}
			disabled={disabled}
			render={({ field: { onChange, value, disabled }, fieldState: { error } }) => (
				<Datepicker
					min={new Date()}
					{...pickerProps}
					date={value}
					onSelect={onChange}
					error={!!error}
					errors={error?.message ? [error?.message] : undefined}
					disabled={disabled}
				/>
			)}
		/>
	);
};
